import { c as _c } from "react/compiler-runtime";
import { BoxProps, Button, ButtonGroup, Separator, Flex, Heading, Icon, SimpleGrid, Stack, StackProps, VStack, Badge } from '@chakra-ui/react';
import { UserSignupRegisterForm } from '@src/components/sco/Account/UserSignupRegisterForm';
import { MarkdownRenderer } from '@src/components/sco/MarkdownRenderer';
import { Paragraph } from '@src/components/sco/Paragraph';
import { SignupRequestPreviewInvestorMatches } from '@src/components/sco/Requests/SignupRequestBuilder/SignupRequestPreviewInvestorMatches';
import { SignupRequestPreviewTasks } from '@src/components/sco/Requests/SignupRequestBuilder/SignupRequestPreviewTasks';
import { SignupRequestPreviewUserMatches } from '@src/components/sco/Requests/SignupRequestBuilder/SignupRequestPreviewUserMatches';
import { generateSignupRequestPreviewTitle } from '@src/components/sco/Requests/SignupRequestBuilder/helpers';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { ScoSignupRequest } from '@src/graphql-types';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import React, { useEffect } from 'react';
import { LuEyeOff } from 'react-icons/lu';
export const SignupRequestPreviewStep = props => {
  const $ = _c(55);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const {
    currentUser
  } = useCurrentUser();
  let t0;
  if ($[0] !== currentUser?.isRegistered || $[1] !== props) {
    t0 = () => {
      if (currentUser?.isRegistered) {
        props.setShowStep("priority");
      }
    };
    $[0] = currentUser?.isRegistered;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = currentUser?.isRegistered;
  let t2;
  if ($[3] !== t1) {
    t2 = [t1];
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t0, t2);
  let matchesType = "goal";
  if (props.groupRequestType?.key) {
    if (props.groupRequestType?.key === "funding") {
      matchesType = "investor";
    } else {
      if (props.groupRequestType?.key !== "goal") {
        matchesType = "user";
      }
    }
  }
  const t3 = props.borderRadius;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [1, 1, 2];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== getBreakpointValue) {
    t5 = getBreakpointValue([2, 4, 4, 4, 4]);
    $[6] = getBreakpointValue;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== getBreakpointValue) {
    t6 = getBreakpointValue([4, 6, 6, 8, 10]);
    $[8] = getBreakpointValue;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== props.signupRequest) {
    t7 = generateSignupRequestPreviewTitle(props.signupRequest);
    $[10] = props.signupRequest;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = props.groupRequestType?.title;
  let t9;
  if ($[12] !== props.signupRequest.investorIndustryTagTitles) {
    t9 = props.signupRequest?.investorIndustryTagTitles || [];
    $[12] = props.signupRequest.investorIndustryTagTitles;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== props.signupRequest.skillTagTitles) {
    t10 = props.signupRequest?.skillTagTitles || [];
    $[14] = props.signupRequest.skillTagTitles;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== props.signupRequest.createdByIpLocation || $[17] !== t10 || $[18] !== t8 || $[19] !== t9) {
    t11 = [t8, ...t9, ...t10, props.signupRequest.createdByIpLocation].filter(Boolean);
    $[16] = props.signupRequest.createdByIpLocation;
    $[17] = t10;
    $[18] = t8;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== props) {
    t12 = () => props.setShowStep("edit");
    $[21] = props;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t11 || $[24] !== t12 || $[25] !== t7) {
    t13 = <SignupRequestPreviewCard title={t7} tags={t11} onEditClick={t12} />;
    $[23] = t11;
    $[24] = t12;
    $[25] = t7;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== matchesType || $[28] !== props.signupRequest) {
    t14 = matchesType === "investor" && <SignupRequestPreviewInvestorMatches signupRequest={props.signupRequest} />;
    $[27] = matchesType;
    $[28] = props.signupRequest;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== matchesType || $[31] !== props.signupRequest) {
    t15 = matchesType === "user" && <SignupRequestPreviewUserMatches signupRequest={props.signupRequest} />;
    $[30] = matchesType;
    $[31] = props.signupRequest;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== matchesType || $[34] !== props.signupRequest) {
    t16 = false && matchesType === "goal" && <SignupRequestPreviewTasks signupRequest={props.signupRequest} />;
    $[33] = matchesType;
    $[34] = props.signupRequest;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== t16 || $[40] !== t5 || $[41] !== t6) {
    t17 = <VStack alignSelf="stretch" background="colorPalette.panel" gap={t5} justify="start" padding={t6} width="full">{t13}{t14}{t15}{t16}</VStack>;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
    $[40] = t5;
    $[41] = t6;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== getBreakpointValue) {
    t18 = getBreakpointValue([4, 6, 6, 8, 10]);
    $[43] = getBreakpointValue;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== props.groupRequestType || $[46] !== props.setShowStep) {
    t19 = <SignupRequestEmailCaptureForm groupRequestType={props.groupRequestType} setShowStep={props.setShowStep} />;
    $[45] = props.groupRequestType;
    $[46] = props.setShowStep;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== t18 || $[49] !== t19) {
    t20 = <VStack alignSelf="stretch" background="LightBlue50" justify="start" padding={t18} width="full">{t19}</VStack>;
    $[48] = t18;
    $[49] = t19;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== props.borderRadius || $[52] !== t17 || $[53] !== t20) {
    t21 = <SimpleGrid borderRadius={t3} columns={t4} gap={0} overflow="hidden">{t17}{t20}</SimpleGrid>;
    $[51] = props.borderRadius;
    $[52] = t17;
    $[53] = t20;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  return t21;
};
type SignupRequestPreviewCardProps = {
  title: string;
  tags: string[];
  parentStackProps?: StackProps;
  statsStackProps?: StackProps;
  onEditClick?: () => any;
};
export const SignupRequestPreviewCard = props => {
  const $ = _c(35);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const isMobile = getBreakpointValue([true, true, false, false, false]);
  const t0 = props.parentStackProps;
  const t1 = isMobile ? "center" : "start";
  const t2 = isMobile ? "center" : "start";
  let t3;
  if ($[0] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 4, 6, 6, 6]);
    $[0] = getBreakpointValue;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== getBreakpointValue) {
    t4 = getBreakpointValue(["1.25em", "1.25em", "1.35em"]);
    $[2] = getBreakpointValue;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = {
      p: {
        lineHeight: 1.33,
        fontFamily: "Poppins",
        fontWeight: "bold",
        fontSize: t4
      }
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== props.title || $[7] !== t5) {
    t6 = <MarkdownRenderer typographyStyles={t5}>{props.title}</MarkdownRenderer>;
    $[6] = props.title;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = props.statsStackProps;
  let t8;
  if ($[9] !== props.tags) {
    t8 = props.tags.map(_temp);
    $[9] = props.tags;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <ButtonGroup gap={1} size="xs">{t8}</ButtonGroup>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== props.statsStackProps || $[14] !== t9) {
    t10 = <Stack align="center" direction="row" gap={2} width="full" {...t7}>{t9}</Stack>;
    $[13] = props.statsStackProps;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t1 || $[17] !== t10 || $[18] !== t2 || $[19] !== t3 || $[20] !== t6) {
    t11 = <VStack align={t1} gap={0} justify={t2} padding={t3} width="full">{t6}{t10}</VStack>;
    $[16] = t1;
    $[17] = t10;
    $[18] = t2;
    $[19] = t3;
    $[20] = t6;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Icon asChild={true} boxSize={4}><LuEyeOff /></Icon>;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = isMobile ? "Your goal isn't public yet." : "Your goal isn't public yet.";
  let t14;
  if ($[23] !== t13) {
    t14 = <Paragraph flex={1} fontSize="sm" opacity={0.8}>{t13}</Paragraph>;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Separator orientation="vertical" />;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== props.onEditClick) {
    t16 = <Button size="xs" variant="outline" onClick={props.onEditClick}>Edit</Button>;
    $[26] = props.onEditClick;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t14 || $[29] !== t16) {
    t17 = <Flex align="center" backgroundColor="colorPalette.bg" color="colorPalette.border" direction="row" gap={2} justify="center" padding={3} width="full">{t12}{t14}{t15}{t16}</Flex>;
    $[28] = t14;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== props.parentStackProps || $[32] !== t11 || $[33] !== t17) {
    t18 = <VStack align="start" background="colorPalette.card/50" borderRadius="xl" boxShadow="sm" direction="column" gap={0} justify="center" overflow="hidden" width="full" {...t0}>{t11}{t17}</VStack>;
    $[31] = props.parentStackProps;
    $[32] = t11;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  return t18;
};
export const SignupRequestEmailCaptureForm = props => {
  const $ = _c(16);
  const {
    getBreakpointValue,
    isMobile
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([2]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = isMobile ? "center" : "start";
  const t2 = isMobile ? "center" : "start";
  const t3 = isMobile ? "center" : "start";
  const t4 = isMobile ? "xl" : "2xl";
  let t5;
  if ($[2] !== t4) {
    t5 = <Heading size={t4}>How should we connect you?</Heading>;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = props.groupRequestType?.signupResultLabel || "details";
  let t7;
  if ($[4] !== t6) {
    t7 = <Paragraph>{"We'll send you "}{t6} right now and connect you every time we find a new match.</Paragraph>;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t5 || $[10] !== t7) {
    t8 = <Flex align={t1} direction="column" gap={2} justify={t2} textAlign={t3} width="full">{t5}{t7}</Flex>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <UserSignupRegisterForm containerProps={{
      boxShadow: "none",
      background: "transparent",
      padding: 0,
      border: "none"
    }} inputProps={{
      size: "lg"
    }} socialLoginButtonsProps={{
      buttonProps: {
        all: {
          variant: "outline"
        }
      }
    }} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t0 || $[14] !== t8) {
    t10 = <VStack align="start" direction="column" gap={t0} justify="center" width="full">{t8}{t9}</VStack>;
    $[13] = t0;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
function _temp(tag) {
  return <Badge key={tag} backgroundColor="colorPalette.muted">{tag}</Badge>;
}